import { img_background } from "../../../assets";
import React from "react";
import style from './index.module.css';

const TNNumberIndicators = () => {
  return (
    <section className={style.deck}>
      <div className={style.deckContent}>
        <ul>
          <li>
            <p>
              <span className={style.icon} />
              87<span className={style.metric}>%</span>
            </p>
            <div className={style.statistic}>
              <p className={style.statisticTitle}>Precision</p>
              <p className={style.statisticDescription}>
                Our patented matching and profiling technology provides unparalleled accuracy and effectiveness for your ad campaigns.
              </p>
            </div>
          </li>
          <li>
            <p>
              <span className={style.icon} /> 20<span className={style.metric}>bln</span>
            </p>
            <div className={style.statistic}>
              <p className={style.statisticTitle}>Ad Appearances Monthly</p>
              <p className={style.statisticDescription}>
                Don't miss out on the potential of billions of monthly ad impressions - trust intent.ai to help you reach your marketing goals.              </p>
            </div>
          </li>
          <li>
            <p
            >
              <span className={style.icon} />
              50<span className={style.metric}>mln</span>
            </p>
            <div className={style.statistic}>
              <p className={style.statisticTitle}>Reachable Users</p>
              <p className={style.statisticDescription}>
                With intent.ai, you can trust that your ad campaigns will reach the right audience, leading to increased ROI and business growth.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <img src={img_background as string} alt="" loading='lazy' className={style.background} />
    </section>
  );
};

export default TNNumberIndicators;
